/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// import { pxToEm } from 'utils/styles/style_helpers';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// ELLIPSIS
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
	ellipsis: {
		display: 'block', // !!!!!! careful, if you have an inline element and wrap it with this ellipsis it may cause unexpected issues
		overflow: 'hidden', 
		whiteSpace: 'nowrap',
		textOverflow: 'ellipsis' // adds the ...
	}
});